var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft4Lengeh9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76 30",
    style: {
      enableBackground: "new 0 0 76 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76,30H0V0h76V30z M1,29h74V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,15.4h-2.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5S27.9,15.4,27.6,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.1,11.4 27.1,18.4 30.6,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,15.7h-2.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5S50.4,15.7,50.1,15.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.9,18.7 47.9,11.7 44.3,15.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,25.3H22V4.4h11.5V25.3z M23,24.4h9.5v-19H23V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,25.3H3.6V4.4H15V25.3z M4.5,24.4H14v-19H4.5V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C38,29.8,37.8,30,37.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C57.3,29.8,57.1,30,56.8,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C19.2,29.8,19,30,18.7,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,15.2H5.5C5.2,15.2,5,15,5,14.7s0.2-0.5,0.5-0.5h6.4c0.3,0,0.5,0.2,0.5,0.5S12.2,15.2,11.9,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v6.7C9.2,18.3,9,18.5,8.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6,15.2h-6.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.4c0.3,0,0.5,0.2,0.5,0.5S69.9,15.2,69.6,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v6.7C66.9,18.3,66.7,18.5,66.4,18.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7,
    y: 4.3,
    width: 38.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: 25.2,
    width: 38.1,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft4Lengeh9);
export default __webpack_public_path__ + "static/media/joft_4_lengeh_9.3e41d810cb2948700c58576df51cf3e4.svg";
export { ForwardRef as ReactComponent };